var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30829 13.75H9.69171V12.25H6.30829V13.75ZM11.25 15.3083V17.5383H12.75V15.3083H11.25ZM11.5383 17.25H4.46166V18.75H11.5383V17.25ZM4.75 17.5383V15.3083H3.25V17.5383H4.75ZM4.46166 17.25C4.62091 17.25 4.75 17.3791 4.75 17.5383H3.25C3.25 18.2075 3.79248 18.75 4.46166 18.75V17.25ZM11.25 17.5383C11.25 17.3791 11.3791 17.25 11.5383 17.25V18.75C12.2075 18.75 12.75 18.2075 12.75 17.5383H11.25ZM9.69171 13.75C10.5523 13.75 11.25 14.4477 11.25 15.3083H12.75C12.75 13.6192 11.3808 12.25 9.69171 12.25V13.75ZM6.30829 12.25C4.61924 12.25 3.25 13.6192 3.25 15.3083H4.75C4.75 14.4477 5.44767 13.75 6.30829 13.75V12.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9436 13.3686C11.3971 13.6619 11.7412 14.1099 11.9011 14.6379C12.1517 14.1128 12.6876 13.7499 13.3083 13.7499H16.6917C17.5523 13.7499 18.25 14.4476 18.25 15.3082V17.2499H12V17.5383C12 17.7933 11.7933 18 11.5383 18H10.3411C10.5226 18.4401 10.956 18.7499 11.4617 18.7499H18.5383C19.2075 18.7499 19.75 18.2075 19.75 17.5383V15.3082C19.75 13.6192 18.3808 12.2499 16.6917 12.2499H13.3083C12.3555 12.2499 11.5045 12.6856 10.9436 13.3686Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/icon-people.35f45827.svg";
export { ForwardRef as ReactComponent };